module.exports = __webpack_public_path__ + "img/lake-cabin-7.0320741b.jpg";